module.exports = __webpack_public_path__ + "media/icons/mailing-facebook-9569c094.png";